<ng-container *ngIf="showAddButton">
<div class="text-right mb-sm-1" style="float: right">
  <span class="btn btn-raised btn-warning" routerLink="{{routeLink}}/add">Добавить</span>
</div>
</ng-container>

<table class="table table-responsive-md table-striped" style="clear: both">
  <thead>
    <tr [ngClass]="isTableHeaderAlignCenter ? 'text-center' : ''">
      <th *ngIf="isIdColumn" class="valign-middle"><!-- --></th>
      <th *ngFor="let itemHeader of columns" class="valign-middle">
        <span *ngIf="itemHeader.isSort" class="primary uf-pointer" (click)="sort(itemHeader.sysName)">
          {{itemHeader.userName}}
          <i class="ft-chevron-down" *ngIf="sortKey==itemHeader.sysName && sortOrder=='asc'"></i>
          <i class="ft-chevron-up" *ngIf="sortKey==itemHeader.sysName && sortOrder=='desc'"></i>
        </span>
        <span *ngIf="!itemHeader.isSort">{{itemHeader.userName}}</span>
      </th>
      <th *ngIf="isActionColumn" class="valign-middle">Действие</th>
    </tr>
  </thead>
  <tbody>
    <!-- filter -->
    <tr style="background: #fbfbfb; border: 0" *ngIf="isFilter">
      <td *ngIf="isIdColumn"><!-- system column --></td>
      <td *ngFor="let columnItem of columns" >
        <app-data-grid-filter *ngIf="columnItem.filter.on"
                              [idGrid]="idGrid"
                              (filterCondition)="getFilterCondition($event)"
                              [column]="columnItem"></app-data-grid-filter>
      </td>
      <td><!-- system column --></td>
    </tr>
    <ng-container *ngIf="pagedItems">
      <tr *ngFor="let item of pagedItems; let trIndex = index" [style.color]="trColor.hasOwnProperty(trIndex) ? trColor[trIndex] : null">
        <td *ngIf="isIdColumn">
          <div class="custom-control custom-checkbox m-0">
            <input type="checkbox" class="custom-control-input" id="item-{{item.id}}">
            <label class="custom-control-label" for="item-{{item.id}}"></label>
          </div>
        </td>
        <!-- set color -->
        <td *ngFor="let itemHeader of columns; let tdIndex = index"
            [style.color]="getTableColumnColor(itemHeader?.colorCondition, item[itemHeader.sysName], trIndex, tdIndex)">
              <ng-container *ngIf="itemHeader.type == 'currency'">
                {{item[itemHeader.sysName] ? (item[itemHeader.sysName] | number: '1.2-2') : '0'}}
              </ng-container>
              <ng-container *ngIf="itemHeader.type== 'date'">
                {{item[itemHeader.sysName] ? (item[itemHeader.sysName] | date: 'dd.LL.yyyy HH:mm:ss') : ''}}
              </ng-container>
              <ng-container *ngIf="itemHeader.type == 'boolean'">
                {{item[itemHeader.sysName] ? '+' : '-'}}
              </ng-container>
              <ng-container *ngIf="itemHeader.type != 'date' && itemHeader.type != 'boolean' && itemHeader.type != 'currency'">
                <!-- especially for lists -->
                {{item[itemHeader.sysNameUser] ? item[itemHeader.sysNameUser] : (item[itemHeader.sysName] ? item[itemHeader.sysName] : '') | striphtml}}
              </ng-container>
        </td>
        <td *ngIf="isActionColumn">
          <ng-container *ngIf="canEditData">
          <a class="success p-0" data-original-title="" title="Отредактировать" routerLink="{{routeLink}}/edit/{{item.id}}" *ngIf="!isActionExternal">
            <i class="ft-edit-2 font-medium-3 mr-2"></i>
          </a>
          <a class="success p-0" data-original-title="" title="Отредактировать" *ngIf="isActionExternal" (click)="editEmit(item)">
            <i class="ft-edit-2 font-medium-3 mr-2"></i>
          </a>
          </ng-container>
          <ng-container *ngIf="canViewData">
            <a class="success p-0" data-original-title="" title="Просмотреть" routerLink="{{routeLink}}/view/{{item.id}}">
              <i class="ft-chevron-right font-medium-3 mr-2"></i>
            </a>
          </ng-container>
          <ng-container *ngIf="canDeleteData">
            <a class="danger p-0" data-original-title="" title="Удалить" (click)="remove(item.id)" *ngIf="!isActionExternal">
              <i class="ft-x font-medium-3 mr-2"></i>
            </a>
            <a class="danger p-0" data-original-title="" title="Удалить" (click)="removeEmit(item.id)" *ngIf="isActionExternal">
              <i class="ft-x font-medium-3 mr-2"></i>
            </a>
          </ng-container>
        </td>
      </tr>
    </ng-container>
  </tbody>
</table>

<ng-container *ngIf="isTotal && pagedItems">
  <div class="row">
    <div class="col-md-12 text-right">
      <b>Итого: {{total |  number}}</b>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="pagedItems">
  <!-- paginator -->
  <app-paginator [pager]="pager" (selectedPage)="isPageable ? setUserPage($event) : setPage($event)" *ngIf="isPaginator"></app-paginator>
</ng-container>

<ng-container *ngIf="!pagedItems">
  <div role="alert" class="alert alert-secondary">
    {{noDataMessage}}
  </div>
</ng-container>
